<template lang="pug">
  .profile-page__main
    .profile-page__body
      .manager-camps-registry
        .manager-shifts-registry__table
          manager-camps-registry-scroll-fix-table(
          :tab-data="tableData"
          :tab-head="tableHead"
          )

</template>

<script>

import {mapState} from "vuex";
import ManagerCampsRegistryScrollFixTable from "./components/ManagerCampsRegistryScrollFixTable";
export default {
  name: "ManagerCampsRegistry",
  components: {ManagerCampsRegistryScrollFixTable},
  data() {
    return {
      tableHead: [
        {
          title: "Лагерь"
        }
      ]
      // tableData: []
    };
  },
  computed: {
    ...mapState(["userData"]),
    tableData() {
      return this.userData.camps;
    }
  },
  mounted() {

  }
};
</script>
